module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.modules_open.skiletting.open && _vm.SITE_CONFIG.rental.currently_discounted) ? _c('div', {
    class: {
      'discount-offer': true, 'clickable': _vm.clickLink
    },
    on: {
      "click": _vm.goToLink
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', [_vm._v("Kampanj på skidhyra")]), _vm._v(" "), _c('p', [_vm._v("* 10% rabatt när du bokar komplett utrustningspaket för hela din boendeperiod.\n      "), (_vm.SITE_CONFIG.site === 'branas') ? _c('span', [_vm._v("Söndag-torsdag, torsdag-söndag och söndag till söndag.")]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('p', {
    staticClass: "smaller"
  }, [_vm._v("(gäller t.o.m. 30/11 2023)")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', {
    staticClass: "smaller"
  }, [_vm._v("(gäller t.o.m. 30/11 2023)")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_vm._v("Just nu "), _c('div', {
    staticClass: "larger"
  }, [_vm._v("10% rabatt*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e3eb5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/SkiRentalDiscount.vue
// module id = 960
// module chunks = 0